var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditableList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15 4H1v9a1 1 0 0 0 1 1h1v1H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1zm-1-3H2a1 1 0 0 0-1 1v1h14V2a1 1 0 0 0-1-1",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 9a2 2 0 0 1 1.5-1.937V5h1v2.063A2 2 0 0 1 7 9v3a2 2 0 0 1-1.5 1.937V16h-1v-2.063A2 2 0 0 1 3 12zm3 3V9a1 1 0 0 0-2 0v3a1 1 0 1 0 2 0M10.5 8.063A2 2 0 0 0 9 10v1a2 2 0 0 0 1.5 1.937V15h1v-2.063A2 2 0 0 0 13 11v-1a2 2 0 0 0-1.5-1.937V6h-1zM12 10v1a1 1 0 1 1-2 0v-1a1 1 0 1 1 2 0",
  clipRule: "evenodd"
})));
export default SvgEditableList;